import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Helper from './_helper';
import 'moment/locale/ja';
moment.locale('ja')

var __h = new Helper();
const vue_news = new Vue({
	el: '#newsEntry',
	data: {
		url: 'https://sgs.liranet.jp/cms/',
		posts: [],
		errors: [],
		isActive: false
	},
	created() {
		axios.get(this.url + 'wp-json/wp/v2/posts?per_page=3&categories=1,6')
		.then(response => {
			this.posts = response.data;
			this.isActive = true;
			for (var post of this.posts) {
				let date_publish = __h.date('YYYY年MM月DD日', post.date);
				post.pubdate = date_publish;
				let isDays = moment().diff(moment(post.date), 'days');
				if (isDays < 30) {
					post.isNew = true;
				} else {
					post.isNew = false;
				}
			}
		})
		.catch(e => {
			this.errors.push(e)
		});
	}
});